export const navInsuranceMenu = [
  [
    {
      key: 'insurance:1',
      url: 'https://carolinas.aaa.com/insurance/',
      label: 'AAA Insurance',
    },
    {
      key: 'insurance:2',
      url: 'https://www.aaacarolinasinsurancesolutions.com/quote/',
      label: 'Get A Quote',
    },
    {
      key: 'insurance:3',
      url: 'https://www.aaacarolinasinsurancesolutions.com/account',
      label: 'Make A Payment',
    },
    {
      key: 'insurance:4',
      url: 'https://carolinas.aaa.com/insurance/claims-and-payments/',
      label: 'File A Claim',
    },
    {
      key: 'insurance:5',
      url: 'https://locator.carolinas.aaa.com/?type=insurance',
      label: 'Find An Agent',
    },
    {
      key: 'insurance:6',
      url: 'https://carolinas.aaa.com/insurance/become-an-agent/',
      label: 'Become An Agent',
    },
  ],
  [
    {
      key: 'insurance:7',
      url: 'https://carolinas.aaa.com/insurance/products/auto/',
      label: 'Auto Insurance',
    },
    {
      key: 'insurance:8',
      url: 'https://carolinas.aaa.com/insurance/products/home/',
      label: 'Home Insurance',
    },
    {
      key: 'insurance:9',
      url: 'https://carolinas.aaa.com/insurance/products/life-insurance/',
      label: 'Life Insurance',
    },
    {
      key: 'insurance:10',
      url: 'https://carolinas.aaa.com/insurance/products/business/',
      label: 'Business Insurance',
    },
    {
      key: 'insurance:11',
      url: 'https://carolinas.aaa.com/insurance/products/inland-flood/',
      label: 'Inland Flood Insurance',
    },
    {
      key: 'insurance:12',
      url: 'https://carolinas.aaa.com/insurance/products/',
      label: 'All Insurance Products',
    },
  ],
];

export const navInsurancePromo = [
  {
    title: 'Manage My Policy',
    content:
      'Manage your AAA Insurance account or view and access insurance documents online quickly and easily.',
    img: '',
    buttonText: 'My Account',
    buttonUrl: 'https://www.aaacarolinasinsurancesolutions.com/account',
  },
];
